import { useState } from 'react';
import Header from '../../components/base/Header';
import Footer from '../../components/base/Footer';

interface FlowerProduct {
  id: number;
  name: string;
  scientificName: string;
  price: string;
  category: string;
  image: string;
  description: string;
  features: string[];
  shopUrl: string;
  rating: number;
  reviews: number;
  inStock: boolean;
  deliveryInfo: string;
}

const flowerProducts: FlowerProduct[] = [
  {
    id: 0,
    name: '鳴滝清流胡蝶蘭 2本立て',
    scientificName: 'Phalaenopsis Premium',
    price: '¥11,000(税込)',
    category: 'orchid',
    image: 'https://static.readdy.ai/image/8ca6952e6a33257e04fb8ac67bcd75fe/6978bbe94c5cfb6f20906d4fd16842e2.png',
    description: '最高級の白い大輪胡蝶蘭2本立て。約85cmの高さで20輪以上の美しい仕立て。7つの特典付きで、お祝いの贈り物に最適です。',
    features: ['2本立て', '大輪20輪以上', '7つの特典付き', '最高級品質', 'ギフト包装無料', '立札・メッセージカード付き'],
    shopUrl: 'https://px.a8.net/svt/ejp?a8mat=45ILCT+49LWEA+4L8W+BW8O2&a8ejpredirect=https%3A%2F%2Fwww.rannohana.com%2Fproduct%2F724',
    rating: 5.0,
    reviews: 28,
    inStock: true,
    deliveryInfo: '翌日配送可能(一部地域除く)'
  },
  {
    id: 1,
    name: '鳴滝清流胡蝶蘭 3本立て',
    scientificName: 'Phalaenopsis Premium',
    price: '¥22,000(税込)',
    category: 'orchid',
    image: 'https://static.readdy.ai/image/8ca6952e6a33257e04fb8ac67bcd75fe/7bba9f54221818f1e4f2a7f36dd78b31.png',
    description: '最高級の白い大輪胡蝶蘭3本立て。約90cmの高さで35-39輪の豪華な仕立て。7つの特典付きで、お祝いの定番として最適です。',
    features: ['3本立て', '大輪35-39輪', '7つの特典付き', '最高級品質', 'ギフト包装無料', '立札・メッセージカード付き'],
    shopUrl: 'https://px.a8.net/svt/ejp?a8mat=45ILCT+49LWEA+4L8W+BW8O2&a8ejpredirect=https%3A%2F%2Fwww.rannohana.com%2Fproduct%2F369',
    rating: 5.0,
    reviews: 38,
    inStock: true,
    deliveryInfo: '翌日配送可能(一部地域除く)'
  },
  {
    id: 2,
    name: '鳴滝清流胡蝶蘭 5本立て',
    scientificName: 'Phalaenopsis Premium',
    price: '¥33,000（税込）',
    category: 'orchid',
    image: 'https://static.readdy.ai/image/8ca6952e6a33257e04fb8ac67bcd75fe/a5152a64f6cda1b17d1dbe2adc1a64fa.png',
    description: '最高級の白い大輪胡蝶蘭5本立て。約95cmの高さで56輪以上の豪華な仕立て。7つの特典付きで、特別なお祝いに最適です。',
    features: ['5本立て', '大輪56輪以上', '7つの特典付き', '最高級品質', 'ギフト包装無料', '立札・メッセージカード付き'],
    shopUrl: 'https://px.a8.net/svt/ejp?a8mat=45ILCT+49LWEA+4L8W+BW8O2&a8ejpredirect=https%3A%2F%2Fwww.rannohana.com%2Fproduct%2F373',
    rating: 5.0,
    reviews: 42,
    inStock: true,
    deliveryInfo: '大型送料3,800円(翌日配送可能)'
  },
  {
    id: 3,
    name: '紅白胡蝶蘭 3本立て',
    scientificName: 'Phalaenopsis Premium',
    price: '¥22,000(税込)',
    category: 'orchid',
    image: 'https://static.readdy.ai/image/8ca6952e6a33257e04fb8ac67bcd75fe/4d61b8e64c07adc1e31a0806c22d4cb8.png',
    description: '縁起の良い紅白の大輪胡蝶蘭3本立て。約90cmの高さで33輪以上の豪華な仕立て。7つの特典付きで、お祝いの贈り物に最適です。',
    features: ['3本立て', '白・ピンク', '大輪33輪以上', '7つの特典付き', '最高級品質', 'ギフト包装無料', '立札・メッセージカード付き'],
    shopUrl: 'https://px.a8.net/svt/ejp?a8mat=45ILCT+49LWEA+4L8W+BW8O2&a8ejpredirect=https%3A%2F%2Fwww.rannohana.com%2Fproduct%2F916',
    rating: 5.0,
    reviews: 35,
    inStock: true,
    deliveryInfo: '翌日配送可能(一部地域除く)'
  },
  {
    id: 4,
    name: '姫葵(ヒメアオイ)大輪 3本立',
    scientificName: 'Phalaenopsis Premium',
    price: '¥22,000(税込)',
    category: 'orchid',
    image: 'https://static.readdy.ai/image/8ca6952e6a33257e04fb8ac67bcd75fe/2b00a8816be264ebc5a75183a5d041d7.png',
    description: '艶やかなピンク色の大輪胡蝶蘭3本立て。約90cmの高さで35輪以上の豪華な仕立て。7つの特典付きで、華やかなお祝いに最適です。',
    features: ['3本立て', 'ピンク大輪', '35輪以上', '7つの特典付き', '最高級品質', 'ギフト包装無料', '立札・メッセージカード付き'],
    shopUrl: 'https://px.a8.net/svt/ejp?a8mat=45ILCT+49LWEA+4L8W+BW8O2&a8ejpredirect=https%3A%2F%2Fwww.rannohana.com%2Fproduct%2F854',
    rating: 5.0,
    reviews: 31,
    inStock: true,
    deliveryInfo: '翌日配送可能(一部地域除く)'
  },
  {
    id: 5,
    name: 'ミニ胡蝶蘭セット',
    scientificName: 'Phalaenopsis Mini Mark',
    price: '¥3,980',
    category: 'orchid',
    image: 'https://public.readdy.ai/ai/img_res/9f15a999f8c3639bf2a3a0da24b1a00e.jpg',
    description: '手のひらサイズの可愛らしいミニ胡蝶蘭のセット。ちょっとした贈り物や自宅用に最適です。',
    features: ['3鉢セット', '育てやすい', 'ギフト包装可', 'お手入れガイド付き'],
    shopUrl: 'https://www.rakuten.co.jp/search/mall/ミニ胡蝶蘭/',
    rating: 4.6,
    reviews: 234,
    inStock: true,
    deliveryInfo: '3-5日でお届け'
  },
  {
    id: 6,
    name: 'ガーデンシクラメン 寄せ植え',
    scientificName: 'Cyclamen persicum',
    price: '¥1,980',
    category: 'cyclamen',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20garden%20cyclamen%20arrangement%20in%20decorative%20planter%2C%20colorful%20winter%20flowers%20in%20pink%20and%20white%2C%20professional%20flower%20shop%20photography%2C%20seasonal%20garden%20display&width=400&height=400&seq=cyclamen-shop-1&orientation=squarish',
    description: '寒さに強いガーデンシクラメンの美しい寄せ植え。冬の庭やベランダを彩ります。',
    features: ['寄せ植え', '耐寒性', '長期間開花', 'お手入れガイド付き'],
    shopUrl: 'https://www.rakuten.co.jp/search/mall/ガーデンシクラメン/',
    rating: 4.5,
    reviews: 145,
    inStock: true,
    deliveryInfo: '3-5日でお届け'
  },
  {
    id: 7,
    name: 'モンステラ 大型株',
    scientificName: 'Monstera deliciosa',
    price: '¥8,800',
    category: 'houseplant',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20large%20monstera%20deliciosa%20houseplant%20with%20split%20leaves%20in%20modern%20pot%2C%20indoor%20tree%20for%20home%20decor%2C%20professional%20plant%20photography%2C%20tropical%20foliage%20display&width=400&height=400&seq=monstera-shop-1&orientation=squarish',
    description: '人気No.1の観葉植物モンステラの大型株。リビングのシンボルツリーとして最適です。',
    features: ['大型株', '切れ込み葉', 'インテリア性抜群', 'お手入れガイド付き'],
    shopUrl: 'https://www.rakuten.co.jp/search/mall/モンステラ+観葉植物/',
    rating: 4.7,
    reviews: 267,
    inStock: true,
    deliveryInfo: '5-7日でお届け（大型商品）'
  },
  {
    id: 8,
    name: 'フィカス・ウンベラータ',
    scientificName: 'Ficus umbellata',
    price: '¥6,980',
    category: 'houseplant',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20ficus%20umbellata%20houseplant%20with%20heart-shaped%20leaves%20in%20stylish%20pot%2C%20elegant%20indoor%20tree%2C%20professional%20plant%20photography%2C%20modern%20home%20decor%20setting&width=400&height=400&seq=ficus-shop-1&orientation=squarish',
    description: 'ハート型の葉が美しいフィカス・ウンベラータ。おしゃれな空間作りに欠かせない観葉植物です。',
    features: ['ハート型葉', 'インテリアツリー', '育てやすい', 'お手入れガイド付き'],
    shopUrl: 'https://www.rakuten.co.jp/search/mall/フィカス+ウンベラータ/',
    rating: 4.6,
    reviews: 198,
    inStock: true,
    deliveryInfo: '5-7日でお届け'
  },
  {
    id: 9,
    name: 'サンスベリア 空気清浄セット',
    scientificName: 'Sansevieria trifasciata',
    price: '¥4,280',
    category: 'houseplant',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20sansevieria%20snake%20plant%20collection%20in%20modern%20pots%2C%20air%20purifying%20houseplants%2C%20professional%20plant%20photography%2C%20minimalist%20interior%20design%2C%20healthy%20green%20foliage&width=400&height=400&seq=sansevieria-shop-1&orientation=squarish',
    description: 'NASA認定の空気清浄植物サンスベリア。寝室やオフィスの空気をきれいにしてくれます。',
    features: ['空気清浄効果', '3鉢セット', '超丈夫', 'お手入れガイド付き'],
    shopUrl: 'https://www.rakuten.co.jp/search/mall/サンスベリア+観葉植物/',
    rating: 4.8,
    reviews: 312,
    inStock: true,
    deliveryInfo: '3-5日でお届け'
  },
  {
    id: 10,
    name: 'ポトス ハンギングセット',
    scientificName: 'Epipremnum aureum',
    price: '¥2,980',
    category: 'houseplant',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20pothos%20hanging%20basket%20arrangement%20with%20trailing%20vines%2C%20variegated%20heart-shaped%20leaves%2C%20professional%20plant%20photography%2C%20modern%20hanging%20garden%20display&width=400&height=400&seq=pothos-shop-1&orientation=squarish',
    description: 'つる性で美しいポトスのハンギングセット。垂れ下がる葉が空間を優雅に演出します。',
    features: ['ハンギング仕様', 'つる性', '育てやすい', 'お手入れガイド付き'],
    shopUrl: 'https://www.rakuten.co.jp/search/mall/ポトス+ハンギング/',
    rating: 4.5,
    reviews: 189,
    inStock: true,
    deliveryInfo: '3-5日でお届け'
  },
  {
    id: 11,
    name: 'ガジュマル 幸福の木',
    scientificName: 'Ficus microcarpa',
    price: '¥5,480',
    category: 'houseplant',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20gajumaru%20ficus%20bonsai%20tree%20with%20thick%20trunk%20and%20aerial%20roots%20in%20decorative%20pot%2C%20Japanese%20lucky%20plant%2C%20professional%20photography%2C%20traditional%20style%20presentation&width=400&height=400&seq=gajumaru-shop-1&orientation=squarish',
    description: '沖縄の精霊が宿る幸福の木ガジュマル。縁起の良い贈り物として人気があります。',
    features: ['幸福の木', '縁起が良い', '盆栽仕立て', 'お手入れガイド付き'],
    shopUrl: 'https://www.rakuten.co.jp/search/mall/ガジュマル+観葉植物/',
    rating: 4.7,
    reviews: 156,
    inStock: true,
    deliveryInfo: '3-5日でお届け'
  },
  {
    id: 12,
    name: 'アロエベラ 薬用植物',
    scientificName: 'Aloe vera',
    price: '¥1,680',
    category: 'houseplant',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20aloe%20vera%20medicinal%20plant%20in%20terracotta%20pot%2C%20thick%20fleshy%20leaves%2C%20professional%20plant%20photography%2C%20natural%20health%20and%20beauty%20setting%2C%20succulent%20display&width=400&height=400&seq=aloe-shop-1&orientation=squarish',
    description: '美容と健康に良いアロエベラ。葉の中のゲルはスキンケアに使える実用的な植物です。',
    features: ['薬用植物', '美容効果', '多肉植物', 'お手入れガイド付き'],
    shopUrl: 'https://www.rakuten.co.jp/search/mall/アロエベラ+植物/',
    rating: 4.4,
    reviews: 123,
    inStock: true,
    deliveryInfo: '3-5日でお届け'
  },
  {
    id: 13,
    name: '季節の花 寄せ植えセット',
    scientificName: 'Seasonal Mix',
    price: '¥3,480',
    category: 'seasonal',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20seasonal%20flower%20arrangement%20with%20colorful%20blooms%20in%20decorative%20planter%2C%20mixed%20flower%20garden%20display%2C%20professional%20flower%20shop%20photography%2C%20vibrant%20spring%20colors&width=400&height=400&seq=seasonal-shop-1&orientation=squarish',
    description: '季節の美しい花々を組み合わせた寄せ植えセット。四季を通じて楽しめる花の組み合わせです。',
    features: ['季節の花', '寄せ植え', '長期間楽しめる', 'お手入れガイド付き'],
    shopUrl: 'https://www.rakuten.co.jp/search/mall/季節の花+寄せ植え/',
    rating: 4.6,
    reviews: 201,
    inStock: true,
    deliveryInfo: '3-5日でお届け'
  },
  {
    id: 14,
    name: 'サンセベリア オベリスポット H80cm',
    scientificName: 'Sansevieria trifasciata',
    price: '¥22,000円（税込）',
    category: 'houseplant',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20tall%20sansevieria%20snake%20plant%20in%20modern%20obelisk%20pot%2C%2080cm%20height%2C%20elegant%20indoor%20plant%20display%2C%20professional%20plant%20photography%2C%20contemporary%20home%20decor%2C%20air%20purifying%20houseplant&width=400&height=400&seq=sansevieria-obelis-1&orientation=squarish',
    description: 'スタイリッシュなオベリスポットに植えられた高さ80cmのサンセベリア。フェイクグリーンなのでお手入れ不要で、空気清浄効果も期待できるデザインです。',
    features: ['フェイクグリーン', 'お手入れ不要', '高さ80cm', 'モダンデザイン', 'オベリスポット', 'インテリア性抜群'],
    shopUrl: 'https://px.a8.net/svt/ejp?a8mat=45ILCT+4LIKHU+4UD8+BW8O2&a8ejpredirect=https%3A%2F%2Fprima-shop.jp%2F%3Fpid%3D189236798',
    rating: 4.7,
    reviews: 89,
    inStock: true,
    deliveryInfo: '3-5日でお届け'
  },
  {
    id: 15,
    name: 'フラワーアレンジメント',
    scientificName: 'Mixed Flower Arrangement',
    price: '¥10,000（税込）',
    category: 'seasonal',
    image: 'https://ginzahanasui.jp/shop/item/flowers/picture/goods/465_1.jpg',
    description: '銀座花水の美しいフラワーアレンジメント。季節の花々を使った華やかなアレンジメントで、お祝いやギフトに最適です。',
    features: ['季節の花', 'プロのアレンジ', 'ギフト包装', '配送対応', '高品質', 'お手入れガイド付き'],
    shopUrl: 'https://px.a8.net/svt/ejp?a8mat=45ILCT+4JQ9OI+5JGA+BW8O2&a8ejpredirect=https%3A%2F%2Fginzahanasui.jp%2Ffs%2Fflowers%2Farrangement%2Far1010',
    rating: 4.8,
    reviews: 156,
    inStock: true,
    deliveryInfo: '翌日配送可能(一部地域除く)'
  },
  {
    id: 16,
    name: 'フラワーアレンジメント ピンク',
    scientificName: 'Mixed Flower Arrangement',
    price: '¥3,850（税込）',
    category: 'seasonal',
    image: 'https://ginzahanasui.jp/shop/item/flowers/picture/goods/425_1.jpg',
    description: '銀座花水の優雅なピンク系フラワーアレンジメント。季節の花々を使った華やかなアレンジメントで、お祝いやギフトに最適です。',
    features: ['季節の花', 'ピンク系', 'プロのアレンジ', 'ギフト包装', '配送対応', 'お手入れガイド付き'],
    shopUrl: 'https://px.a8.net/svt/ejp?a8mat=45ILCT+4JQ9OI+5JGA+BW8O2&a8ejpredirect=https%3A%2F%2Fginzahanasui.jp%2Ffs%2Fflowers%2Farrangement_5000%2Far0305',
    rating: 4.8,
    reviews: 142,
    inStock: true,
    deliveryInfo: '翌日配送可能(一部地域除く)'
  }
];

const categories = [
  { id: 'all', name: 'すべて', icon: 'ri-plant-line' },
  { id: 'orchid', name: '胡蝶蘭', icon: 'ri-leaf-line' },
  { id: 'airplant', name: 'エアプランツ', icon: 'ri-seedling-line' },
  { id: 'cyclamen', name: 'シクラメン', icon: 'ri-flower-line' },
  { id: 'houseplant', name: '観葉植物', icon: 'ri-home-garden-line' },
  { id: 'seasonal', name: '季節の花', icon: 'ri-calendar-line' }
];

const priceRanges = [
  { id: 'all', name: 'すべて', min: 0, max: Infinity },
  { id: 'under3000', name: '3,000円以下', min: 0, max: 3000 },
  { id: '3000to10000', name: '3,000円〜10,000円', min: 3000, max: 10000 },
  { id: 'over10000', name: '10,000円以上', min: 10000, max: Infinity }
];

export default function FlowerShop() {
  const [selectedCategory, setSelectedCategory] = useState('all');
  const [selectedPriceRange, setSelectedPriceRange] = useState('all');
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedProduct, setSelectedProduct] = useState<FlowerProduct | null>(null);

  const filteredProducts = flowerProducts.filter(product => {
    const matchesCategory = selectedCategory === 'all' || product.category === selectedCategory;
    const priceRange = priceRanges.find(range => range.id === selectedPriceRange);
    const price = parseInt(product.price.replace(/[¥,]/g, ''));
    const matchesPrice = !priceRange || (price >= priceRange.min && price <= priceRange.max);
    const matchesSearch = product.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         product.scientificName.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         product.description.toLowerCase().includes(searchTerm.toLowerCase());
    
    return matchesCategory && matchesPrice && matchesSearch && product.inStock;
  });

  const handlePurchase = (product: FlowerProduct) => {
    window.open(product.shopUrl, '_blank');
  };

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      {/* Hero Section */}
      <section 
        className="relative py-24 bg-cover bg-center"
        style={{
          backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url('https://readdy.ai/api/search-image?query=Beautiful%20online%20flower%20shop%20with%20various%20plants%20and%20flowers%20for%20sale%2C%20professional%20flower%20arrangement%20display%2C%20modern%20botanical%20retail%20setting%2C%20soft%20natural%20lighting%2C%20elegant%20shopping%20atmosphere&width=1920&height=600&seq=flower-shop-hero&orientation=landscape')`
        }}
      >
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-5xl md:text-6xl font-bold text-white mb-6">
            花と植物のオンラインショップ
          </h1>
          <p className="text-xl text-white/90 mb-8 max-w-3xl mx-auto leading-relaxed">
            美しい花と植物をお手軽にお求めいただけます。
            <br />
            厳選された高品質な商品を全国にお届けいたします。
          </p>
        </div>
      </section>

      {/* Search and Filter Section */}
      <section className="py-12 bg-gradient-to-br from-green-50 to-blue-50">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            {/* Search Bar */}
            <div className="mb-8">
              <div className="relative max-w-md mx-auto">
                <input
                  type="text"
                  placeholder="商品名で検索..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  className="w-full px-4 py-3 pl-12 rounded-full border border-gray-200 focus:outline-none focus:ring-2 focus:ring-green-500 text-sm"
                />
                <i className="ri-search-line absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400 text-sm"></i>
              </div>
            </div>

            {/* Category Filter */}
            <div className="mb-6">
              <h3 className="text-lg font-semibold text-gray-800 mb-4 text-center">カテゴリー</h3>
              <div className="flex flex-wrap justify-center gap-2">
                {categories.map((category) => (
                  <button
                    key={category.id}
                    onClick={() => setSelectedCategory(category.id)}
                    className={`px-4 py-2 rounded-full text-sm font-medium transition-all cursor-pointer whitespace-nowrap ${
                      selectedCategory === category.id
                        ? 'bg-green-500 text-white'
                        : 'bg-white text-gray-700 hover:bg-green-100'
                    }`}
                  >
                    <i className={`${category.icon} mr-2`}></i>
                    {category.name}
                  </button>
                ))}
              </div>
            </div>

            {/* Price Filter */}
            <div>
              <h3 className="text-lg font-semibold text-gray-800 mb-4 text-center">価格帯</h3>
              <div className="flex flex-wrap justify-center gap-3">
                {priceRanges.map((range) => (
                  <button
                    key={range.id}
                    onClick={() => setSelectedPriceRange(range.id)}
                    className={`px-3 py-2 rounded-full text-sm font-medium transition-all cursor-pointer whitespace-nowrap ${
                      selectedPriceRange === range.id
                        ? 'bg-blue-500 text-white'
                        : 'bg-white text-gray-700 hover:bg-blue-100'
                    }`}
                  >
                    {range.name}
                  </button>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Products Grid */}
      <section className="py-16" data-product-shop>
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-800 mb-4">
              {filteredProducts.length}商品が見つかりました
            </h2>
            <p className="text-gray-600">高品質な花と植物をお手頃価格でお届けします</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
            {filteredProducts.map((product) => (
              <div
                key={product.id}
                className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition-all group"
                data-product-shop
              >
                <div className="relative">
                  <img
                    src={product.image}
                    alt={product.name}
                    className="w-full h-48 object-cover object-top group-hover:scale-105 transition-transform duration-300"
                  />
                  <div className="absolute top-3 right-3 bg-white/90 backdrop-blur-sm px-2 py-1 rounded-full text-xs font-medium text-gray-700">
                    在庫あり
                  </div>
                </div>
                <div className="p-4">
                  <h3 className="text-lg font-bold text-gray-800 mb-2">{product.name}</h3>
                  <p className="text-xs text-gray-500 mb-2 italic">{product.scientificName}</p>
                  
                  <div className="flex items-center gap-2 mb-3">
                    <span className="text-2xl font-bold text-green-600">{product.price}</span>
                  </div>

                  <div className="flex items-center gap-2 mb-3">
                    <div className="flex items-center">
                      {[...Array(5)].map((_, i) => (
                        <i
                          key={i}
                          className={`ri-star-${i < Math.floor(product.rating) ? 'fill' : 'line'} text-yellow-400 text-sm`}
                        ></i>
                      ))}
                    </div>
                    <span className="text-xs text-gray-500">({product.reviews}件)</span>
                  </div>

                  <p className="text-gray-600 text-xs mb-4 line-clamp-2">{product.description}</p>

                  <div className="flex flex-wrap gap-1 mb-4">
                    {product.features.slice(0, 2).map((feature, index) => (
                      <span
                        key={index}
                        className="bg-green-100 text-green-800 px-2 py-1 rounded-full text-xs font-medium"
                      >
                        {feature}
                      </span>
                    ))}
                  </div>

                  <div className="space-y-2">
                    <button
                      onClick={() => handlePurchase(product)}
                      className="w-full bg-green-600 hover:bg-green-700 text-white py-2 px-4 rounded-lg font-semibold transition-colors cursor-pointer whitespace-nowrap"
                    >
                      購入する
                    </button>
                    <button
                      onClick={() => setSelectedProduct(product)}
                      className="w-full bg-gray-100 hover:bg-gray-200 text-gray-700 py-2 px-4 rounded-lg font-medium transition-colors cursor-pointer whitespace-nowrap"
                    >
                      詳細を見る
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {filteredProducts.length === 0 && (
            <div className="text-center py-16">
              <i className="ri-search-line text-6xl text-gray-300 mb-4"></i>
              <h3 className="text-xl font-semibold text-gray-600 mb-2">該当する商品が見つかりません</h3>
              <p className="text-gray-500">検索条件を変更してお試しください</p>
            </div>
          )}
        </div>
      </section>

      {/* Product Detail Modal */}
      {selectedProduct && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center p-4 z-50">
          <div className="bg-white rounded-3xl max-w-2xl w-full max-h-[90vh] overflow-y-auto">
            <div className="relative">
              <img
                src={selectedProduct.image}
                alt={selectedProduct.name}
                className="w-full h-64 object-cover object-top"
              />
              <button
                onClick={() => setSelectedProduct(null)}
                className="absolute top-4 right-4 bg-white/90 backdrop-blur-sm w-10 h-10 rounded-full flex items-center justify-center hover:bg-white transition-colors cursor-pointer"
              >
                <i className="ri-close-line text-xl"></i>
              </button>
            </div>
            <div className="p-8">
              <div className="flex items-start justify-between mb-6">
                <div>
                  <h2 className="text-3xl font-bold text-gray-800 mb-2">{selectedProduct.name}</h2>
                  <p className="text-gray-500 text-lg italic">{selectedProduct.scientificName}</p>
                </div>
                <div className="text-right">
                  <div className="flex items-center gap-2 mb-2">
                    <span className="text-3xl font-bold text-green-600">{selectedProduct.price}</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <div className="flex items-center">
                      {[...Array(5)].map((_, i) => (
                        <i
                          key={i}
                          className={`ri-star-${i < Math.floor(selectedProduct.rating) ? 'fill' : 'line'} text-yellow-400`}
                        ></i>
                      ))}
                    </div>
                    <span className="text-sm text-gray-500">({selectedProduct.reviews}件)</span>
                  </div>
                </div>
              </div>

              <div className="mb-6">
                <h3 className="text-xl font-semibold text-gray-800 mb-3">商品説明</h3>
                <p className="text-gray-600 leading-relaxed">{selectedProduct.description}</p>
              </div>

              <div className="mb-6">
                <h3 className="text-xl font-semibold text-gray-800 mb-3">特徴</h3>
                <div className="flex flex-wrap gap-2">
                  {selectedProduct.features.map((feature, index) => (
                    <span
                      key={index}
                      className="bg-green-100 text-green-800 px-3 py-1 rounded-full font-medium"
                    >
                      {feature}
                    </span>
                  ))}
                </div>
              </div>

              <div className="mb-6">
                <h3 className="text-xl font-semibold text-gray-800 mb-3">配送情報</h3>
                <p className="text-gray-600">{selectedProduct.deliveryInfo}</p>
              </div>

              <button
                onClick={() => handlePurchase(selectedProduct)}
                className="w-full bg-green-600 hover:bg-green-700 text-white py-3 px-6 rounded-lg text-lg font-semibold transition-colors cursor-pointer whitespace-nowrap"
              >
                購入ページへ進む
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Shopping Tips Section */}
      <section className="py-16 bg-gradient-to-br from-green-50 to-blue-50">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-800 mb-4">お買い物ガイド</h2>
            <p className="text-gray-600">安心してお買い物いただくために</p>
          </div>

          <div className="grid md:grid-cols-3 gap-8 max-w-4xl mx-auto">
            <div className="bg-white rounded-2xl p-6 shadow-lg">
              <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center mb-4">
                <i className="ri-truck-line text-2xl text-green-600"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-800 mb-3">安心配送</h3>
              <p className="text-gray-600">専門スタッフが丁寧に梱包し、植物に最適な環境でお届けします。</p>
            </div>

            <div className="bg-white rounded-2xl p-6 shadow-lg">
              <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center mb-4">
                <i className="ri-shield-check-line text-2xl text-blue-600"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-800 mb-3">品質保証</h3>
              <p className="text-gray-600">厳選された高品質な植物のみを取り扱い、万が一の場合は交換対応いたします。</p>
            </div>

            <div className="bg-white rounded-2xl p-6 shadow-lg">
              <div className="w-12 h-12 bg-purple-100 rounded-full flex items-center justify-center mb-4">
                <i className="ri-customer-service-line text-2xl text-purple-600"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-800 mb-3">アフターサポート</h3>
              <p className="text-gray-600">購入後のお手入れ方法や育て方について、専門スタッフがサポートします。</p>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
